import { useEffect } from "../../../__compat__/react/main.entry.mjs.mjs";
export const useEscapeKey = (callback) => {
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                callback();
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [callback]);
};
//# sourceMappingURL=use-esc-key-listener.mjs.mjs.map